module.exports = __webpack_public_path__ + "static/media/clearSDGFilter.6b05eae9.svg";